import {useLocation, useNavigate, useParams} from "react-router";
import {useCallback, useEffect, useState} from "react";
import {Character} from "@/characters/model/Character.ts";
import {getCharacterById} from "@/api/CharacterApi.ts";
import CharacterForm from "@/characters/admin/form/CharacterForm.tsx";
import {SaveCharacterRequest} from "@/characters/admin/form/CharacterFormSchema.ts";
import {useSaveCharacterMutation} from "@/characters/CharacterQueries.ts";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import ConfirmDialog from "@/components/forms/ConfirmDialog.tsx";
import {useUnsavedChangesGuard} from "@/hooks/useUnsavedChangesGuard.ts";

export default function CharacterEditView() {

    const {id} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const {campaignPath} = useCampaign();
    const [character, setCharacter] = useState<Character | null>(null);
    const [dirty, setDirty] = useState(false);
    const saveMutation = useSaveCharacterMutation();
    const {run: guardNavigation, dialogProps} = useUnsavedChangesGuard(dirty);

    useEffect(() => {
        if (id) getCharacterById(id).then((res) => setCharacter(res))
    }, [id]);

    const onSubmit = async (request: SaveCharacterRequest) => {
        const saved = await saveMutation.mutateAsync(request);
        setCharacter(saved);
        setDirty(false);
        return saved;
    }

    const cancel = useCallback(() => guardNavigation(() => {
        setDirty(false);
        navigate({pathname: campaignPath(`characters/${id}`), search: location.search}, {replace: true});
    }), [campaignPath, guardNavigation, id, location.search, navigate]);

    if (!character) return null

    return (
        <>
            <title>{`${character.name} bearbeiten | DireDawn`}</title>
            <ConfirmDialog {...dialogProps}/>
            <CharacterForm defaultValue={character}
                           onSubmit={onSubmit}
                           onCancel={cancel}
                           onDirtyChange={setDirty}/>
        </>
    );
}
